export const REDUCER_KEY_HEATMAP = 'Heatmap';
export const SET_HEATMAP_OPEN = 'Heatmap/SET_HEATMAP_OPEN';
export const SET_SETTINGS = 'Heatmap/SET_SETTINGS';
export const FETCH_HEATMAP_DATA = 'Heatmap/FETCH_HEATMAP_DATA';
export const FETCH_HEATMAP_DATA_SUCCESS = 'Heatmap/FETCH_HEATMAP_DATA_SUCCESS';
export const FETCH_HEATMAP_DATA_FAILURE = 'Heatmap/FETCH_HEATMAP_DATA_FAILURE';
export const UPDATE_HEATMAP_DATA = 'Heatmap/UPDATE_HEATMAP_DATA';
export const SET_SELECTION_INFO = 'Heatmap/SET_SELECTION_INFO';

export const HEATMAP_OBSERVABLE_TOPICS = {
  resizeWindow: 'HEATMAP:RESIZE_WINDOW',
  resizeHeader: 'HEATMAP:RESIZE_HEADER',
  scrollWindow: 'HEATMAP:SCROLL_WINDOW',
  clickCell: 'HEATMAP:CLICK_CELL',
  movedNavigator: 'HEATMAP:MOVED_NAVIGATOR',
  verticalSplitter: 'HEATMAP:headerResizedTopics:vertical',
  horizontalSplitter: 'HEATMAP:headerResizedTopics:horizontal',
};

export const HEATMAP_SPLITTER_CHANGE_STATES = {
  activated: 0,
  moved: 1,
  released: 2,
};

export const HEATMAP_VIEW_PARAMS = {
  maxDensityDiameter: 24,
  minDensityDiameter: 4,
  colsHeaderHeight: 160 + 40,
  rowsHeaderWidth: 160 + 40,
  cellWidth: 32, // also used as default and minimum width of column headers
  cellHeight: 32, // also used as default and minimum height of row headers
  minOfVisibleRows: 30,
  viewBufferSize: 2, // viewport * viewBufferSize = amount of cells to render
  dataBufferSize: 2, // viewport * viewBufferSize * dataBufferSize = amount of data for loading from BE
  overlapToFetch: 0.25, // how large part of preloaded data should be scrolled to trigger request to BE for data
  maxRequestColsRows: 250, // maximum 250 cols and 250 rows are allowed to fetch at once
  scrollDebounce: 300,
  scrollDebounceQuick: 10,
  navigatorFiredDebounce: 500,
  resizeDebounce: 1000,
  resizeInProgressDebounce: 250,
  viewChangeDebounce: 150,
  substanceType: 'DAT.MRN',
  targetType: 'DAT.TNAME',
  substanceDrawingType: 'drawing',
  cellWidthWithStructure: 140,
  cellHeightWithStructure: 140,
};
